export enum CancellationReasonTypes {
  finalPrice = 'Final Price',
  competitor = 'Competitor',
  privatePlate = 'Private Plate',
}
